import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent } from '@material-ui/core';
import DropzoneUploader from '../DropzoneUploader';
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper';
import Typography from '@material-ui/core/Typography';

const ProfilePic = props => {
  const { imageURL, name, imageType, handleImageChange, editable } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [newImageURL, setNewImageURL] = useState('');

  const handleClickOpen = () => {
    if (editable) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    handleClose();
    handleImageChange(newImageURL);
  };

  const handleStatusChange = (fileObj, status) => {
    if (status === DropzoneUploader.UPLOAD_STATES.DONE) {
      const { xhr } = fileObj;
      const response = JSON.parse(xhr.response);

      const { context } = response;

      if (context && context.location) {
        setNewImageURL(context.location);
      }
    }
  };

  return (
    <div className={classes.root}>
      <AvatarWrapper
        alt="Click to Edit"
        className={classes.avatar}
        imageUrl={imageURL}
        name={name}
        onClick={handleClickOpen}
        placeholder="Click to Edit"
      />
      <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        maxWidth="sm"
        onClose={handleClose}
        open={open}>
        <DialogTitle id="alert-dialog-title">
          <Typography style={{ whiteSpace: 'pre-line', lineHeight: '20px' }} variant="h4">{`Change Display Image ${
            name ? `For ${name}` : ''
          } \n Max Size: 1 MB`}</Typography>
        </DialogTitle>
        <DialogContent>
          <DropzoneUploader
            acceptedFiles="image/jpg,image/jpeg,image/png"
            handleStatusChange={handleStatusChange}
            maxFiles={1}
            PreviewComponent={DropzoneUploader.AvatarPreview}
            queryParams={imageType ? { type: imageType } : {}}
            showSubmitButton={false}
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button autoFocus color="secondary" onClick={handleSubmit} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ProfilePic.propTypes = {
  imageURL: PropTypes.string,
  name: PropTypes.string,
  handleImageChange: PropTypes.func,
  imageType: PropTypes.string,
  editable: PropTypes.bool,
};

ProfilePic.defaultProps = {
  imageURL: '',
  name: '',
  handleImageChange: () => null,
  imageType: '',
  editable: false,
};

export default ProfilePic;
